import { Box, Paper, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

const CustomClock = ({
  showDate = true,
  timeTextVariant = 'h4',
  dateTextVariant = 'subtitle1',
  sx = {},
  sxBox = {},
  sxTime = {},
  sxDate = {},
}) => {
  const [now, setNow] = useState(new Date())
  const [showColon, setShowColon] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date())
      setShowColon((prev) => !prev) // blinking colon
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const hours = now.toLocaleTimeString(undefined, { hour: '2-digit' }).padStart(2, '0')
  const minutes = now.toLocaleTimeString(undefined, { minute: '2-digit' }).padStart(2, '0')
  const seconds = now.toLocaleTimeString(undefined, { second: '2-digit' }).padStart(2, '0')
  const dateString = now.toLocaleDateString(undefined, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          ...sxBox,
        }}
      >
        <Typography
          variant={timeTextVariant}
          sx={{
            fontFamily: 'monospace',
            whiteSpace: 'nowrap',
            ...sxTime,
          }}
        >
          <span style={{ display: 'inline-block', width: '2ch' }}>{hours}</span>
          <span>:</span>
          <span style={{ display: 'inline-block', width: '2ch' }}>{minutes}</span>
          <span style={{ opacity: showColon ? 1 : 0 }}>:</span>
          <span style={{ display: 'inline-block', width: '2ch' }}>{seconds}</span>
        </Typography>

        {showDate && (
          <Typography variant={dateTextVariant} sx={sxDate}>
            {dateString}
          </Typography>
        )}
      </Box>
    </Paper>
  )
}

export default CustomClock
